import { State } from "../../../state/store";
import { useSelector } from "react-redux";
import { Disease } from "../../../domain/disease_knowledge/Disease";
import { SearchedDisease } from "../../../domain/disease_knowledge/SearchedDisease";
import { DiseaseCategory } from "../../../domain/disease_knowledge/DiseaseCategory";

export const useSearchedDiseases = (): Return => {
    const responseJson = useSelector((state: State) => state.diseaseKnowledge.searchedDiseases);

    const { keyword, processing }  = useSelector((state: State) => state.diseaseKnowledge);
    
    return {
        keyword: keyword,
        resultList: responseJson?.searchedDiseases.map(searchedDisease =>
            new SearchedDisease(
                new Disease(searchedDisease.id, searchedDisease.name),
                DiseaseCategory.categoryFrom(searchedDisease.category.id, searchedDisease.category.name),
                searchedDisease.symptoms
            )
        ) ?? [],
        isProcessing: processing > 0 || !responseJson
    };
};

type Return = {
    keyword: string
    resultList: SearchedDisease[]
    isProcessing: boolean
}